import React from 'react';
import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {Tabs} from "../../../../core/components/tabs/components/tabs";
import classNames from "classnames";
import styles from "../../styles/competitor-players-stats-module.module.scss"

export const CompetitorPlayersStatsModulePlayerStatsTabs = observer(({controller}: BaseProps) => {
  const {state} = controller;
  const {shouldRenderTabs, activeTabIndex, tabs} = state

  const onTabChange = (tab) => {
    controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.tabChange, {tab: tab});

    return false
  }

  const tabProps = {
    shouldRenderTabs,
    initialIndex: activeTabIndex,
    tabs,
    className: classNames(styles.tabs),
    onTabChange: (tab) => onTabChange(tab)
  }

  return (
    shouldRenderTabs ? <Tabs {...tabProps}/> : null
  )
});
